<template>
  <div class="content">
    <el-row style="height: 33%">
      <!-- 生产工单 -->
      <el-col :span="10" style="height: 100%">
        <div class="content_block scgd">
          <div class="people_title">
            <span class="left_title">生产工单</span>
          </div>
          <Scgd />
        </div>
      </el-col>
      <!-- 运行情况 -->
      <el-col :span="4" style="height: 100%">
        <div class="content_block running">
          <div class="yxing_title">
            <span class="left_title">运行情况</span>
          </div>
          <Running />
        </div>
      </el-col>
      <!-- 仓库管理 -->
      <el-col :span="10" style="height: 100%">
        <div class="content_block ckgl">
          <div class="people_title">
            <span class="left_title">仓库管理</span>
          </div>
          <Ckgl />
        </div>
      </el-col>
    </el-row>
    <el-row style="height: 33%">
      <!-- 质量管理 -->
      <el-col :span="9" style="height: 100%">
        <div class="content_block zlgl">
          <div class="people_title">
            <span class="left_title">质量管理</span>
          </div>
          <Zlgl />
        </div>
      </el-col>
      <!-- 设备管理 -->
      <el-col :span="6" style="height: 100%">
        <div class="content_block sbgl">
          <div class="sbei_title">
            <span class="left_title">设备管理</span>
          </div>
          <Sbgl />
        </div>
      </el-col>
      <!-- 工艺流程 -->
      <el-col :span="9" style="height: 100%">
        <div class="content_block gylc">
          <div class="people_title">
            <span class="left_title">工艺流程</span>
          </div>
          <div style="height: 100%; padding: 10px 30px 0 30px">
            <Gylc />
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row style="height: 33%">
      <!-- 人员统计 -->
      <el-col :span="12" style="height: 100%">
        <div class="content_block people">
          <div class="people_title">
            <span class="left_title">人员统计</span>
          </div>
          <People />
        </div>
      </el-col>
      <!-- 监控设备 -->
      <el-col :span="12" style="height: 100%">
        <div class="content_block jksb">
          <div class="people_title">
            <span class="left_title">每日统计</span>
          </div>
          <Jksb />
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import People from './components/people.vue';
import Gylc from './components/gylc.vue';
import Running from './components/running.vue';
import Jksb from './components/jksb.vue';
import Ckgl from './components/ckgl.vue';
import Scgd from './components/scgd.vue';
import Zlgl from './components/zlgl.vue';
import Sbgl from './components/sbgl.vue';
export default {
  components: {
    Running,
    People,
    Gylc,
    Jksb,
    Ckgl,
    Scgd,
    Zlgl,
    Sbgl
  },
  data () {
    return {
    }
  }
}
</script>
<style lang="scss" scoped>
.content {
  width: 100%;
  height: calc(100% - 70px); /* 计算剩余的高度并应用 */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .scgd {
    background: url("~@/assets/imgs/生产工单bg.png") no-repeat;
  }
  .ckgl {
    background: url("~@/assets/imgs/仓库管理bg.png") no-repeat;
  }
  .zlgl {
    background: url("~@/assets/imgs/质量管理bg.png") no-repeat;
  }
  .sbgl {
    background: url("~@/assets/imgs/设备管理bg.png") no-repeat;
  }
  .gylc {
    background: url("~@/assets/imgs/工艺流程bg.png") no-repeat;
  }
  .running {
    background: url("~@/assets/imgs/运行情况bg.png") no-repeat;
  }
  .people {
    background: url("~@/assets/imgs/人员统计bg.png") no-repeat;
  }
  .jksb {
    background: url("~@/assets/imgs/监控设备bg.png") no-repeat;
  }
  .content_block {
    background-size: 100% 100%;
    border: 1px solid #35b1ff;
    display: flex;
    flex-direction: column;
    height: 100%;
    margin: 0px 4px;
    padding: 10px;
    .yxing_title {
      width: 100%;
      height: 38px;
      background: url("~@/assets/imgs/运行情况title.png") no-repeat;
      background-size: 100% 100%;
      padding-left: 12px;
    }
    .sbei_title {
      width: 100%;
      height: 38px;
      background: url("~@/assets/imgs/设备管理title.png") no-repeat;
      background-size: 100% 100%;
      padding-left: 12px;
    }
    .people_title {
      width: 100%;
      height: 38px;
      background: url("~@/assets/imgs/人员统计title.png") no-repeat;
      background-size: 100% 100%;
      padding-left: 12px;
    }
    .left_title {
      width: 71px;
      height: 18px;
      font-family: Alimama ShuHeiTi;
      font-weight: bold;
      font-size: 18px;
      color: #ffffff;
      line-height: 32px;
    }
  }
}
@-webkit-keyframes ripple {
  0% {
    box-shadow: 0 0 0 0 rgba(93, 177, 210, 0.3),
      0 0 0 1em rgba(93, 177, 210, 0.3);
  }

  50% {
    box-shadow: 0 0 0 1em rgba(93, 177, 210, 0.3),
      0 0 0 3em rgba(93, 177, 210, 0.3);
  }
  51% {
    box-shadow: 0 0 0 0 rgba(93, 177, 210, 0.3),
      0 0 0 1em rgba(93, 177, 210, 0.3);
  }

  100% {
    box-shadow: 0 0 0 1em rgba(93, 177, 210, 0.3),
      0 0 0 3em rgba(93, 177, 210, 0.3);
  }
}

@keyframes ripple {
  0% {
    box-shadow: 0 0 0 0 rgba(93, 177, 210, 0.3),
      0 0 0 1em rgba(93, 177, 210, 0.3);
  }

  50% {
    box-shadow: 0 0 0 1em rgba(93, 177, 210, 0.3),
      0 0 0 3em rgba(93, 177, 210, 0.3);
  }
  51% {
    box-shadow: 0 0 0 0 rgba(93, 177, 210, 0.3),
      0 0 0 1em rgba(93, 177, 210, 0.3);
  }

  100% {
    box-shadow: 0 0 0 1em rgba(93, 177, 210, 0.3),
      0 0 0 3em rgba(93, 177, 210, 0.3);
  }
}
.circle-ripple {
  background-color: #5db1c9;
  border-radius: 50%;
  -webkit-animation: ripple 2s linear infinite;
  animation: ripple 2s linear infinite;
  animation-delay: 1s;
  position: absolute;
  z-index: 1;
  border-radius: 100%;
  width: 100px;
  height: 100px;
  top: 89px;
}
</style>
<style lang="scss">
.progressFont .el-progress__text {
  font-size: 25px !important;
}
</style>